import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { apiListCities, apiListCountries, apiListStates } from 'Services/AuthService'

export const getCountries = createAsyncThunk('list/getCountries', async () => {
    const { data } = await apiListCountries()
    return data
})

export const getStates = createAsyncThunk('list/getStates', async id => {
    const { data } = await apiListStates(id)
    return data
})

export const getCities = createAsyncThunk('list/getCities', async id => {
    const { data } = await apiListCities(id)
    return data
})

export const listSlice = createSlice({
    name: 'list',
    initialState: {
        loading: true,
        countries: [],
        states: [],
        cities: [],
    },
    extraReducers: builder => {
        builder
            .addCase(getCountries.fulfilled, (state, { payload }) => {
                state.countries = payload
            })
            .addCase(getCountries.rejected, state => {
                state.countries = []
            })
            .addCase(getStates.fulfilled, (state, { payload }) => {
                state.states = payload
            })
            .addCase(getStates.rejected, state => {
                state.states = []
            })
            .addCase(getCities.fulfilled, (state, { payload }) => {
                state.cities = payload
            })
            .addCase(getCities.rejected, state => {
                state.cities = []
            })
    },
})

export default listSlice.reducer
